import { Dispatch } from 'react';
import { OrgResultsConst } from '../utils/constants/orgResults';
import OrgResultsServices from "../services/orgResults.services";

const orgResultsServices = new OrgResultsServices();

export const fetchUserList = (params: any={}) => async (dispatch: Dispatch<any>,  getState: any) => {
  try {
    const { defaultUserList } = getState();
    if((params.term && params.term.length > 0) ||  !defaultUserList){
        orgResultsServices.getUsersList({ term: params.term }).then(function (
          response
        ) {
          if (response.data) {
            dispatch({
              type: OrgResultsConst.FETCH_USER_LIST,
              payload: response.data.data,
              term: params.term
            });
          }
        });
    }else{
      dispatch({
        type: OrgResultsConst.PUSH_DEFAULT_USER_LIST,
        term: params.term
      });
    }
    
  }
  catch(e) {

  }
}

export const pushDeafultUserList = (params: any) => {
  return {
    type: OrgResultsConst.PUSH_DEFAULT_USER_LIST, 
  }
}

export const updateSelection =  (params: any={}) => async (dispatch: Dispatch<any>,  getState: any) => {
  showLoaderWidget($("#content"));
  orgResultsServices.getOrgResults(params).then(response => {
    if (response.data) {
      dispatch({
        type: OrgResultsConst.UPDATE_ORG_RESULTS,
        selectedValue: params.timestamp,
        goalData: response.data.data.goalData,
        teamProgress: response.data.data.teamProgress,
        daysleft:response.data.data.daysleft,
        dateAsOf: response.data.data.dateAsOf,
        forData: response.data.data.forData,
        objKey: response.data.data.objKey,
        directReporteeLists: response.data.data.directReporteeLists,
        QTDResults: response.data.data.QTDResults,
        pQuaterName: response.data.data.pQuaterName,
        cQuaterName: response.data.data.cQuaterName,
      });
    }
    removeLoaderWidget();
  });
}


export const getPopupData =  (params: any={}) => async (dispatch: Dispatch<any>,  getState: any) => {
  orgResultsServices.getPopupData({
    type: params.type,
    userId: params.forData.userId,
    teamId: params.forData.teamId,
    offset: params.offset,
    timestamp: params.forData.timestamp
  }).then(response => {
    if (response.data) {
     
      dispatch({
        type: OrgResultsConst.UPDATE_POPUP_DATA,
        payload: response.data.data,
        membersCount: response.data.members_count,
        offset: params.offset,
        isAllFetched: response.data.data.length === 0 ? true : false,
      });
    }
    removeLoaderWidget();
  });

  if(params.type){ // event track on click of top 20 , bottom 20 , 0% , 100% 
    let ref ;
    if(params.type === "top") {
      ref = 'RESULTS_ANALYTICS_TOP20';
    } else if (params.type === "bottom"){
      ref = 'RESULTS_ANALYTICS_BOTTOM20';
    } else if (params.type === "zero"){
      ref = 'RESULTS_ANALYTICS_ZERO';
    } else if (params.type === "hundred"){
      ref = 'RESULTS_ANALYTICS_HUNDRED';
    }
    if(ref) {
      orgResultsServices.resultAnalyticsEvents({
      ref : ref,
      teamId: params.forData.teamId,
      timeFrame: params.timeFrame})
    }
  }
}

export const nudgeAll =  (params: any) => async (dispatch: Dispatch<any>,  getState: any) => {
  orgResultsServices.nudgeAll({
    teamId: params.teamId,
    userId: params.userId,
    timestamp: params.timestamp,
    type: params.type,
    subject: params.subject,
    message: params.message
  }).then(response => {
    if (response.data) {
      removeLoaderWidget();
      metricPingStatus("OKR owners");
    }
  });
  if (params.type) { // event track for send nudge/message
    let ref ;
    if (params.type === "top") {
      ref = 'RESULTS_ANALYTICS_KUDOS_SEND';
    } if (params.type === "hundred") {
      ref = 'RESULTS_ANALYTICS_MESSAGE_SEND';
    } if (params.type === "bottom" || params.type === "zero") {
      ref = 'RESULTS_ANALYTICS_NUDGE_SEND';
    } 
    if(ref){
        orgResultsServices.resultAnalyticsEvents({
        ref : ref,
        teamId: params.teamId,
        timeFrame: params.timeFrame
      })
    }
  }

}